import { Link } from "react-router-dom";
import { CATEGORIES } from "../lib/constants";
import { ArrowRight } from "@phosphor-icons/react";

export default function Categories() {
  return (
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-12">
      <div className="mb-10">
        <div className="text-xs font-bold uppercase tracking-[0.3em] text-primary mb-3">Le tribù</div>
        <h1 className="font-display text-4xl sm:text-6xl font-black uppercase tracking-tighter" data-testid="categories-title">Categorie</h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {CATEGORIES.map((c, i) => (
          <Link
            key={c.id}
            to={`/events?category=${c.id}`}
            data-testid={`cat-card-${c.id}`}
            className="group relative aspect-[4/5] overflow-hidden border border-border rounded-sm bg-card fade-in-up"
            style={{ animationDelay: `${i * 60}ms`, transition: "border-color 0.3s cubic-bezier(0.4,0,0.2,1)" }}
            onMouseEnter={(e) => e.currentTarget.style.borderColor = "hsl(3 100% 59%)"}
            onMouseLeave={(e) => e.currentTarget.style.borderColor = ""}
          >
            <img src={c.image} alt={c.name} className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105" style={{ transition: "transform 0.6s cubic-bezier(0.4,0,0.2,1), opacity 0.3s" }} />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
            <div className="relative h-full flex flex-col justify-between p-8">
              <div className="text-xs font-black uppercase tracking-[0.3em] text-primary">{c.tag}</div>
              <div>
                <h3 className="font-display font-black text-3xl uppercase tracking-tighter leading-none mb-3">{c.name}</h3>
                <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-neutral-300">
                  Esplora eventi <ArrowRight size={12} weight="bold" />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
